import { CtaButton } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledListings = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(${rem('340px')}, 1fr));
  gap: ${rem('32px')};
  padding-top: ${rem('24px')};
  padding-bottom: ${rem('40px')};
  width: 100%;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.m}) {
    grid-template-columns: 1fr;
  }
`;

export const StyledTitle = styled.h2`
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('28px')};
  font-weight: 600;
  margin: 0;
`;

export const StyledTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem('24px')};
`;

export const StyledTopBar = styled.div`
  margin: ${rem('16px')} 0 0 0;

  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const StyledShowMoreCtaButton = styled(CtaButton)`
  text-transform: uppercase;
  margin-bottom: ${rem('56px')};
  height: ${rem('48px')};
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${rem('16px')};
`;

export const StyledAddCtaButton = styled(CtaButton)`
  text-transform: uppercase;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.m}) {
    padding: ${rem('10px')};
  }
`;

export const StyledAddIcon = styled.div`
  position: relative;
  width: ${rem('16px')};
  height: ${rem('16px')};

  &::before,
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: ${({ theme }) => theme.colors.main};
  }

  &::after {
    width: 100%;
    height: ${rem('2px')};
  }

  &::before {
    width: ${rem('2px')};
    height: 100%;
  }
`;
